import * as React from 'react'
import { Chip } from '@material-ui/core'
import { mainTheme } from '../../utils/mainTheme'

interface CouponStatusChipProps {
  status: 'active' | 'inactive' | 'expired' | 'archived'
}

const CouponStatusChip: React.FC<CouponStatusChipProps> = ({ status }) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'active':
        return {
          label: 'Ativo',
          color: mainTheme.palette.success.main,
          backgroundColor: mainTheme.palette.success.light,
        }
      case 'inactive':
        return {
          label: 'Inativo',
          color: mainTheme.palette.warning.main,
          backgroundColor: '#FFF3E0',
        }
      case 'expired':
        return {
          label: 'Expirado',
          color: mainTheme.palette.error.main,
          backgroundColor: mainTheme.palette.error.light,
        }
      case 'archived':
        return {
          label: 'Arquivado',
          color: mainTheme.palette.grey[400],
          backgroundColor: mainTheme.palette.grey[100],
        }
      default:
        return {
          label: 'Desconhecido',
          color: mainTheme.palette.grey[400],
          backgroundColor: mainTheme.palette.grey[100],
        }
    }
  }

  const config = getStatusConfig(status)

  return (
    <Chip
      label={config.label}
      size="small"
      style={{
        color: config.color,
        backgroundColor: config.backgroundColor,
        fontWeight: 600,
        fontSize: '0.7rem',
        height: '24px',
        borderRadius: '12px',
      }}
    />
  )
}

export default CouponStatusChip
